import history from 'appHistory';

export const goToLoginPage = () => {
  history.push('/');
};

export const goToMainPage = () => {
  history.push('/kassa24');
};
